// extracted by mini-css-extract-plugin
module.exports = {"inline-menu":"Menu_inline-menu__1rHXK"};